<template>
  <div class="changelogDashboard">
  <NavbarComponent :loadingStatus="loading">Changelog</NavbarComponent>
  <section class="chagenlogSection">
  <div v-if="!loading" class="container is-fluid">
    <div class="box">
      <br>
    
<h3 class="title is-3">To Do</h3>
<li>Colour picker for report groups</li>
<li>Change default colourway option</li>
<li>Wrike report password validation</li>
<li>Wrike report completed and created date options backend tie-in.</li>
<li>Optimise Apogee Health Check Report processing time in backend (by data transforms and/or indexing)</li>
<li>Further optimisations to reduce loading times (especially initial loading time)</li>
<li>MSIB datasource tool to combine EDES and create a msib import file (brainstorm)</li>
<br><br>
<br><br>
<h3 class="title is-3">April 2025</h3>

<h5 class ="title is-5">Improvements and Bugfixes</h5>
<li>Updated token verfication to use MSAL library</li>
<br><br>


<h3 class="title is-3">July 2024</h3>

<h5 class ="title is-5">Improvements and Bugfixes</h5>
<li>Updated server libraries and security patches</li>
<li>Updated backend libraries</li>
<li>Updated frontend libraries (up to Vue 2.7.16)</li>
<li>Updated Dockerfile Images</li>
<br><br>

<h3 class="title is-3">November 2023</h3>

<h5 class ="title is-5">New Features</h5>
<li>Updated authentication to use Azure AD/Entra ID instead of the depreciated MyId</li>
<li>Disabled monitoring platform card as no longer being used</li>
<br><br>

<h3 class="title is-3">November 2022</h3>

<h5 class ="title is-5">Improvements and Bugfixes</h5>
<li>Updated units and report groups in store.</li>
<li>Added filter exponent in data and validation dashboards. 
This removes values that have an "e+" or "e-" in the response from Navigator, which is usually erroneous values</li>
<br><br>




<h3 class="title is-3">July 2022</h3>

<h5 class ="title is-5">Improvements and Bugfixes</h5>
<li>Added Machine Account Credentials stripping blank characters to help with login problems</li>
<li>Changed Navigator machine account oAuth2 authentication inline with Navigator update 
(client_id and client_secret sent in request body now instead of Authorization header)</li>
<br><br>


<h3 class="title is-3">May 2022</h3>
<h5 class ="title is-5">Improvements and Bugfixes</h5>
<li>Fixed API Endpoint call to tree dimension root. </li>

<br><br>

<h3 class="title is-3">August 2021</h3>
<h5 class ="title is-5">Improvements and Bugfixes</h5>
<li>Added Siemens Brandville styling to Login and Homepages</li>
<li>Homepage cards are now clickable instead of just the card titles. </li>
<br><br>

<h3 class="title is-3">August 2021</h3>
<h5 class ="title is-5">New Features</h5>
<li>Added Wrike Generate Report Tool</li>
<li>Added Reports Public Page to view wrike reports</li>
<li>Added Add Highlight buttton for data dashboard graphs. </li>
<li>Added CSV meter data export monthly option for data dashboard</li>
<li>Added Apogee Health Check Report Functionality </li>

<br>
<h5 class ="title is-5">Improvements and Bugfixes</h5>
<li>Changed Public Graphs to default to full screen if only one chart is in the data. </li>
<li>Added warning to navbar when MyId access token has expired. </li>
<li>Added Last Month option to Date Range selects for data and validation dashboards</li>
<li>Added modular options for Wrike Report</li>
<li>Added created and completed date option placeholers for Wrike Report </li>
<li>Optimised Navigator AU Tools size by 30% by removing unused libraries and using Plotly min.</li>
<li>Fixed random dots appearing in pagination of tables in modal (dots appears if table is wrapped in 'content' div)</li>
<li>Added renew MyId access token,then removed renew functionality because iframes not supported by MyId content security policy</li>
<br>
<h5 class ="title is-5">Backend Changes</h5>
<li>Added a whole bunch of endpoints to create, get report data from backend</li>
<li>Added endpoints to view individual Wrike tasks (will only retrieve if task ID is in report)</li>
<li>Added endpoints to download Wrike attacahments (will only retrieve if task ID is in report</li>
<li>Added Wrike Public Report Model to backend</li>
<li>Added Wrike API Model to backend</li>
<li>Added empty constructor to Wrike report for modules turned off, so frontend rendering is consistent.</li>
<br><br>

<h3 class="title is-3">July 2021</h3>
<h5 class ="title is-5">New Features</h5>
<li>Added Datasources tool dashboard - tool to upload new MSIB files list of datasources to change, with assitive tools to match new datasources or easily change new datasources,
as well as generate modified NDMT and culled MSIB files </li>
<li>Added new "Save Data as File" options for data dashboard including different layouts and xlsx format.</li>
<li>Added card link to "ASC AU Monitoring Platform" tool on homepage (superusers only)</li>
<li>Fixed public graphs buttons not staying persistent on mobile resolutions</li>
<li>Fixed save as xlsx master sheet to iterate through meter names properly</li>
<li>Search and tree is now scrollable</li>
<br><br>


<h3 class="title is-3">June 2021</h3>
<h5 class ="title is-5">New Features</h5>
<li>Added "Create Public Graph" feature - quickly create public acccessible urls to show graphs. Links expire after the specified time and as password protectable.</li>
<li>Added "Saved Meters Collection" feature for data dashboard - save collections of meters and data range settings and load them back</li>
<li>Added "Page settings" feature for data dashboard - data dashboard settings will persist for user's browser</li>
<li>Added "Animated bubble chart" feature for data dashboard - create animated bubble charts</li>
<li>Added "Does not contain" filter option</li>
<li>Added "Remove All Meters" button to "does not contain" filter to remove all filtered search items from meter list.</li>
<li>Added "Copy Graphs to Clipboard" button for data dashboard</li>
<li>Added "Save Graphs As Single Image" button for data dashboard</li>
<li>Added "Save Graphs As Multiple Images" button for data dashboard</li>
<li>Added "Editable Graphs" checkbox for data dashboard</li>
<li>Added "Display Mode Bar" button for data dashboard - the interactive toolbar on top right of graphs</li>
<li>Added read-only and superuser-only dashboard settings for homepage</li>
<li>Created User management dashboard (superuser only)</li>
<li>Created Machine account management dashboard (superuser only)</li>
<li>Created Changelog dashboard (superuser only)</li>


<br>
<h5 class ="title is-5">Improvements and Bugfixes</h5>
<li>Fixed "Readings" in data dashboard to use Navigator meter timezone properly.</li>
<li>Changed dash dashboard charts to explicity format datetimes now. New charts have propety chartVersion: 2, and old charts are explicity handled where appropriate</li>
<li>Fixed public graphs converting to local timezone twice. New generated ones will have times already explicity formatted to meter timezone.</li>
<li>Fixed data dashboard graph artifacts over-time by forcing charts DOM to rerender everytime there are new graphs</li>
<li>Improved - Graph by Nodes chart now gets node names from Navigator instead of displaying node Id</li>
<li>Added report group Ids and names in store (current as of 21st April 2021) so they can be looked up.</li>
<li>Added reactivechart-withbubblegraphs component specific for public graph pages that does not rerender bubblegraphs</li>
<li>Improved - Data dashboard meter data is now sorted by reportgroupId first before graphing to give more consistent colouring</li>
<li>Adjusted sort calculation so cooling coil valve command/position gets sorted before heating coil valve command/position as report group IDs are inconsistent</li>
<li>Changed automatic refresh of Navigator Machine Account access tokens from 9 minutes to 4.5 minutes, to attempt to get 2 before access expires.</li>
<li>Changed interpolation dashboard to not be viewable or accessible for read-only users</li>
<li>Changed data deleter dashboard to not be viewable or accessible for read-only users</li>
<li>Changed zero deleter dashboard to not be viewable or accessible for read-only users</li>
<li>Changed colours to fit latest Siemens brandville</li>
<li>Changed graph default colourway to Siemens brandville colours</li>

<br>
<h5 class ="title is-5">Backend Changes</h5>
<li>Added database</li>
<li>GID now authenticated with user data from database</li>
<li>Added users model in backend</li>
<li>Added machine account model in backend</li>
<li>Added saved meters collections model in backend</li>
<li>Added public graphs model in backend</li>
<li>Created User REST API endpoints</li>
<li>Created Machine Account REST API endpoints</li>
<li>Created Public Graphs REST API endpoints</li>
<li>Created Saved Meters Collections REST API endpoints</li>








<br><br>

<h3 class="title is-3">May 2021</h3>
<h5 class ="title is-5">New Features</h5>
<li>Converted authentication and login to use Siemens MyId</li>
<br>
<h5 class ="title is-5">Backend Changes</h5>
<li>Navigator machine account credentials server only - only temporary access tokens are retrived</li>
<li>Authentication uses OIDC and SiemensMyId JWKs to get GID</li>
<li>Created front end and backend docker image with traefik proxy and gunicorn</li>
<li>Created forward proxy</li>
<li>Created navigator-au-tools domain</li>
<li>Created AWS EC2 instance</li>
<li>Production version deployed to AWS EC2 instance</li>


    </div>
 </div>
 </section>
  </div>
</template>

<script>
import _ from 'lodash';
import NavbarComponent from '@/components/NavbarComponent.vue'



export default {
  name: 'NavigatorScriptDownloader',
  props: {
  },
  components: {NavbarComponent},
  data() {return {
    loading: false,
    message: '',

    }
  },
  methods:{
  },
  mounted() {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
